import { CompositePropagator, W3CBaggagePropagator, W3CTraceContextPropagator } from '@opentelemetry/core';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { ConsoleSpanExporter, SimpleSpanProcessor, WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { resourceFromAttributes } from '@opentelemetry/resources';
import { ATTR_SERVICE_NAME, ATTR_SERVICE_VERSION, ATTR_USER_AGENT_ORIGINAL } from '@opentelemetry/semantic-conventions';
import { ALLOW_ALL_BAGGAGE_KEYS, BaggageSpanProcessor } from '@opentelemetry/baggage-span-processor';
import resolveEnv, { PROD } from '@agentnet/utils';
import { bootstrapPropagation } from '../propagation/propagation';

const SERVICE_NAME = 'agentnet-web';
const SERVICE_VERSION = '1.0.0';

let initialized = false;

export function setupTelemetry(corsUrls: RegExp[]): void {
  if (initialized) return;
  initialized = true;

  const resource = resourceFromAttributes({
    ...(typeof navigator !== 'undefined' ? { [ATTR_USER_AGENT_ORIGINAL]: navigator.userAgent } : {}),
    [ATTR_SERVICE_NAME]: SERVICE_NAME,
    [ATTR_SERVICE_VERSION]: SERVICE_VERSION,
  });

  const shouldExport = resolveEnv() !== PROD;

  const provider = new WebTracerProvider({
    resource,
    spanProcessors: [
      ...(shouldExport ? [new SimpleSpanProcessor(new ConsoleSpanExporter())] : []),
      new BaggageSpanProcessor(ALLOW_ALL_BAGGAGE_KEYS),
    ],
  });

  provider.register({
    propagator: new CompositePropagator({
      propagators: [new W3CTraceContextPropagator(), new W3CBaggagePropagator()],
    }),
  });

  registerInstrumentations({
    instrumentations: [
      new FetchInstrumentation({
        propagateTraceHeaderCorsUrls: corsUrls,
        clearTimingResources: true,
      }),
    ],
  });

  bootstrapPropagation();
}
